export default {
  'order.subsEvent': 'Order Event',
  'order.time': 'Time',
  'order.date': 'Date',
  'order.other': 'Other',
  'order.operator': 'Operator',
  'order.serviceNumber': 'Service Number',
  'order.custOrderID': 'Customer Order ID',
  'order.orderState': 'Order State',
  'order.statusType': 'Order Status Type',
  'order.account': 'Account',
  'order.state': 'State',
  'order.inprocess': 'Inprocess',
  'order.complete': 'Complete',
  'order.userCode': 'User Code',
  'order.userName': 'User Name',
  'order.number': 'Order Number',
  'order.orderTime': 'Order Time',
  'order.orderType': 'Order Type',
  'order.total.amount': 'Total Amount',
  'order.customer.name': 'Customer Name',
  'order.customer.account': 'Customer Account',
  'order.accountItemType': 'Account Item Type',
  'order.amountReceivable': 'Amount Receivable',
  'order.discountAmount': 'Discount Amount',
  'order.amountReceived': 'Amount Received',
  'order.documentName': 'Document Name',
  'order.action': 'Action',
  'order.download': 'Download',
  'order.payment': 'Payment',
  'order.detailTitle': 'Order Information',
  'order.selectUpload': 'Select Upload',
  'order.clickToUpload': 'Click to Upload',
  'order.uploadContract': 'Upload File',
  IMAGE_TWO_LARGE: 'Image must smaller than 2MB!',
  ORDER_UPLOAD_JPG_NPG_ERROR:
    'File format must be PDF or Picture (BMP, JPG, JPEG, PNG, GIF)',
  'order.select.operator': 'Select Operator',
  'order.select.member': 'Select Member Modal',
  'order.basicInformation': 'Basic Information',
  'order.attachments': 'Attachments',
  'order.orderItemList': 'Order Item List',
  'order.feeInformation': 'Fee Information',
  'order.subsInfo': 'Subscriber Information',
  'order.serviceList': 'Services List',
  'order.resourceInformation': 'Resource Information',
  'order.itemMemo': 'Order Item Memo',
  'order.accountNumber': 'Account Number',
  'order.mainOffer': 'Main Offer',
  'order.mainProduct': 'Main Product',
  'order.orderAction': 'Order Action',
  'order.archiveDate': 'Order Archive Date',
  'order.3ppOrderNum': '3PP Order Number',
  'order.remark': 'Remarks',
  'order.name': 'Name',
  'order.newValue': 'New Value',
  'order.oldValue': 'Old Value',
  'order.offerName': 'Offer Name',
  'order.operationType': 'Operation Type',
  'order.effectiveType': 'Effective Type / Effective Date',
  'order.effectiveDuration': 'Effective Duration / Expire Date',
  'order.resourceType': 'Resource Type',
  'order.newResourceNumber': 'New Resource Number',
  'order.oldResourceNumber': 'Old Resource Number',
  'order.permanent': 'Permanent',
  'order.iccid': 'ICCID',
  'order.deliveryOrderDetail': 'Delivery Order Detail',
  'order.progressUpdate': 'Progress Update',
  'order.orderStage': 'Order Stage',
  'order.createdDate': 'Created Date',
  'order.address': 'Address',
  'order.goods': 'Goods',
  'order.quantity': 'Quantity',
  'order.trackingNo': 'Tracking No',
  'order.courier': 'Courier',
  'order.deliveryStatus': 'Delivery Status',
  'order.deliveryStatusDate': 'Delivery Status Date',
  'order.proposeReappointment': 'Propose Reappointment',
  'order.reappointmentCategory': 'Reappointment Category',
  'order.reappointmentReason': 'Reappointment Reason',
  'order.changeAppointment': 'Change Appointment',
  'order.thereIsNoTime': 'There is no avaiable time slot on this day.',
  'order.installationInformation': 'Installation Information',
  'order.serviceAddress': 'Service Address',
  'order.apointmentDate': 'Appointment Date',
  'order.processUpdate': 'Process Update',
  'order.installer': 'Installer',
  'order.setAppointment': 'SET APPOINTMENT',
  'order.trackTMCareCrew': 'Track TM Care Crew',
};
